"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionSubtotal = exports.Section = exports.SectionDescription = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importDefault(require("react"));
var TokenRenderer_1 = __importDefault(require("@CommonFrontend/ContentTokens/TokenRenderer"));
var Recurrence_1 = require("@CommonFrontendBackend/QuoteV2/Recurrence");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var QuoteSummaryContextProvider_1 = require("./QuoteSummaryContextProvider");
var styles = __importStar(require("./QuoteSummaryWidget.css"));
var Utils_1 = require("./Utils");
var DiscountableTotal_1 = require("./DiscountableTotal");
var LineItemComponents_1 = require("./LineItemComponents");
var classnames_1 = __importDefault(require("classnames"));
var SectionDescription = function (_a) {
    var section = _a.section;
    var settings = (0, QuoteSummaryContextProvider_1.useQuoteSummaryContext)().settings;
    if (!section.description || !section.description.tokens || section.description.tokens.length === 0) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    var tokens = section.description.tokens;
    if (settings.compactSectionHeaders) {
        tokens = (0, Utils_1.getFirstContentOfType)(section.description.tokens, ["heading1", "heading2", "paragraph"]);
    }
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.sectionDescription, "section-description"), dangerouslySetInnerHTML: {
            __html: (0, TokenRenderer_1.default)(tokens),
        } }));
};
exports.SectionDescription = SectionDescription;
var Section = function (_a) {
    var section = _a.section, labelSetId = _a.labelSetId, viewSettings = _a.viewSettings;
    var _b = (0, QuoteSummaryContextProvider_1.useQuoteSummaryContext)(), getLabel = _b.getLabel, settings = _b.settings;
    var _c = section.viewSettings, showItemQuantity = _c.showItemQuantity, showItemRate = _c.showItemRate, showItemTotal = _c.showItemTotal, showItemDescription = _c.showItemDescription, showItemSubtotal = _c.showItemSubtotal;
    var showSubtotal = section.displayMode === Types_1.QuoteSectionDisplayMode.PlanCards ? !!viewSettings.showQuoteTotals : !!showItemSubtotal;
    var showDescription = section.displayMode === Types_1.QuoteSectionDisplayMode.PlanCards ? settings.showPlanSectionHeaders : true;
    var items = section.items.filter(function (item) {
        if (settings.showTextItems) {
            return true;
        }
        else {
            return item.type !== Types_1.QuoteItemType.Text;
        }
    });
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: "section-wrapper" },
        showDescription && react_1.default.createElement(exports.SectionDescription, { section: section }),
        react_1.default.createElement("table", { className: "section-table" },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", { className: (0, classnames_1.default)(styles.colHeadingRow, "section-header-row") },
                    react_1.default.createElement("th", { className: styles.colHeading({ isFirstColumn: true }) }, showItemDescription && react_1.default.createElement("p", null, getLabel(labelSetId, Types_1.QuoteLabel.Description))),
                    react_1.default.createElement("th", { className: styles.colHeading() }, showItemRate && react_1.default.createElement("p", null, getLabel(labelSetId, Types_1.QuoteLabel.Item))),
                    react_1.default.createElement("th", { className: styles.colHeading() }, showItemQuantity && react_1.default.createElement("p", null, getLabel(labelSetId, Types_1.QuoteLabel.Quantity))),
                    react_1.default.createElement("th", { className: styles.colHeading({ align: "right" }) }, showItemTotal && react_1.default.createElement("p", null, getLabel(labelSetId, Types_1.QuoteLabel.Price))))),
            react_1.default.createElement("tbody", { className: styles.section }, items.map(function (item, index) { return (react_1.default.createElement(LineItemComponents_1.LineItemRow, { item: item, key: index, sectionViewSettings: section.viewSettings, labelSetId: labelSetId, isLastRow: items.length - 1 === index })); }))),
        showSubtotal && (react_1.default.createElement(kaleidoscope_1.Stack, { align: "end", className: "section-footer" },
            react_1.default.createElement("table", { className: styles.total },
                react_1.default.createElement(exports.SectionSubtotal, { total: section.total, labelSetId: labelSetId, discount: section.discount, showSubtotal: showSubtotal }))))));
};
exports.Section = Section;
var SectionSubtotal = function (_a) {
    var total = _a.total, labelSetId = _a.labelSetId, discount = _a.discount, _b = _a.showSubtotal, showSubtotal = _b === void 0 ? false : _b;
    var getLabel = (0, QuoteSummaryContextProvider_1.useQuoteSummaryContext)().getLabel;
    if (!showSubtotal) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    var totals = [
        { frequency: null, preTax: total.preTax, preDiscount: total.preDiscount },
    ];
    if (total.recurringTotals) {
        Object.keys(total.recurringTotals).forEach(function (key) {
            var _a, _b, _c, _d;
            if ((0, Types_1.isRecurringFrequency)(key)) {
                var frequency = key;
                totals.push({
                    preTax: (_b = (_a = total.recurringTotals[frequency]) === null || _a === void 0 ? void 0 : _a.preTax) !== null && _b !== void 0 ? _b : 0,
                    frequency: frequency,
                    preDiscount: (_d = (_c = total.recurringTotals[frequency]) === null || _c === void 0 ? void 0 : _c.preDiscount) !== null && _d !== void 0 ? _d : 0,
                });
            }
        });
    }
    var sortedTotals = (0, Utils_1.sortByDisplayOrder)(totals);
    var hideOneOffLabel = sortedTotals.length === 1 && sortedTotals[0].frequency === null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("tfoot", null,
            react_1.default.createElement("tr", { className: "section-subtotal" },
                react_1.default.createElement("td", { className: styles.subTotalCell() },
                    react_1.default.createElement("p", { className: styles.subTotalItem }, getLabel(labelSetId, Types_1.QuoteLabel.SubTotal))),
                react_1.default.createElement("td", { className: styles.subTotalCell({ align: "right" }) }, sortedTotals.map(function (total) {
                    var _a;
                    var label = total.frequency
                        ? getLabel(labelSetId, (0, Recurrence_1.mapRecurringFrequencyToPerLabel)(total.frequency))
                        : hideOneOffLabel
                            ? ""
                            : getLabel(labelSetId, Types_1.QuoteLabel.OneOff);
                    return (react_1.default.createElement(DiscountableTotal_1.DiscountableTotal, { key: "subtotal-".concat(total.frequency), discount: discount, labelSetId: labelSetId, preTax: total.preTax, preDiscount: (_a = total.preDiscount) !== null && _a !== void 0 ? _a : 0, frequencyLabel: label }));
                }))))));
};
exports.SectionSubtotal = SectionSubtotal;
